import { render } from "./FormEditorPdf.vue?vue&type=template&id=3dbcacec&scoped=true"
import script from "./FormEditorPdf.vue?vue&type=script&lang=js"
export * from "./FormEditorPdf.vue?vue&type=script&lang=js"

import "./FormEditorPdf.vue?vue&type=style&index=0&id=3dbcacec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbcacec"]])

export default __exports__